/* Lunera PDP — buy box, gallery (click + mobile swipe), rail arrows, timeline.
   Init is readyState-aware and runs ONCE: the script is injected by every section,
   and DOMContentLoaded may already have fired by the time it loads. */
(function(){
  function init(){
    if (window.__luneraPdpInit) return;   /* bind once, even though the file loads many times */
    window.__luneraPdpInit = true;

    /* ---------- CART DRAWER: guarantee scroll is restored on close ----------
       Dawn locks body scroll (body.overflow-hidden) when the drawer opens. When we open it
       programmatically via renderContents, its close path can occasionally leave the lock on,
       freezing the page. Watch the drawer and restore scrolling whenever it isn't active. */
    (function(){
      var cd = document.querySelector('cart-drawer');
      if (!cd || !('MutationObserver' in window)) return;
      function restore(){
        if (!cd.classList.contains('active')) {
          document.body.classList.remove('overflow-hidden');
          document.documentElement.classList.remove('overflow-hidden');
          document.body.style.overflow = '';
        }
      }
      new MutationObserver(restore).observe(cd, { attributes: true, attributeFilter: ['class'] });
    })();

    /* ---------- BUY BOX ---------- */
    [].slice.call(document.querySelectorAll('.buybox[data-sub-rate]')).forEach(function(box){
      var subRate = parseFloat(box.getAttribute('data-sub-rate')) || 0.85;
      var tiers = [].slice.call(box.querySelectorAll('[data-tier]'));
      var subRow = box.querySelector('[data-sub]');
      var priceEl = box.querySelector('[data-atc-price]');
      var subMonths = box.querySelector('[data-sub-months]');
      function selected(){ return box.querySelector('[data-tier][aria-checked="true"]') || tiers[0]; }
      function fmt(n){ return '£' + n.toFixed(2); }
      function render(){
        var t = selected();
        var sub = subRow && subRow.getAttribute('aria-checked') === 'true';
        var months = t.getAttribute('data-months');
        if (subMonths) subMonths.textContent = 'every ' + months + ' month' + (months === '1' ? '' : 's');
        tiers.forEach(function(x){
          var b = parseFloat(x.getAttribute('data-price'));
          var cur = sub ? b : b / subRate;
          var pe = x.querySelector('.tier__price');
          if (pe) pe.textContent = fmt(cur);
          /* v2 buy box extras — all null-guarded so the old repeat buy box is unaffected */
          var tubs = parseFloat(x.getAttribute('data-tubs'));
          var pt = x.querySelector('[data-bb-pertub]');
          if (pt && tubs > 0) pt.textContent = fmt(cur / tubs);
          var cmp = parseFloat(x.getAttribute('data-compare'));
          if (cmp > 0) {
            var pc = x.querySelector('[data-bb-pct]');
            if (pc) pc.textContent = Math.round((1 - cur / cmp) * 100) + '%';
            var sv = x.querySelector('[data-bb-save]');
            if (sv) sv.textContent = Math.round(cmp - cur);
          }
        });
        var base = parseFloat(t.getAttribute('data-price'));
        if (priceEl) priceEl.textContent = fmt(sub ? base : base / subRate);
      }
      tiers.forEach(function(t){
        t.addEventListener('click', function(){
          tiers.forEach(function(x){ x.setAttribute('aria-checked','false'); });
          t.setAttribute('aria-checked','true'); render();
        });
      });
      if (subRow) subRow.addEventListener('click', function(){
        subRow.setAttribute('aria-checked', subRow.getAttribute('aria-checked') === 'true' ? 'false' : 'true'); render();
      });
      var atc = box.querySelector('[data-atc]');
      if (atc) atc.addEventListener('click', function(e){
        e.preventDefault();
        var t = selected();
        var variant = t.getAttribute('data-variant');
        var plan = t.getAttribute('data-plan');
        var sub = subRow && subRow.getAttribute('aria-checked') === 'true';
        if (!variant) { alert('This tier has no product assigned yet — set one in the theme editor.'); return; }
        var item = { id: parseInt(variant, 10), quantity: 1 };
        if (sub && plan) item.selling_plan = parseInt(plan, 10);
        var items = [item];
        var g1 = t.getAttribute('data-gift1'); if (g1) items.push({ id: parseInt(g1, 10), quantity: 1, properties: { 'Free gift': 'Included with your bundle' } });
        var g2 = t.getAttribute('data-gift2'); if (g2) items.push({ id: parseInt(g2, 10), quantity: 1, properties: { 'Free gift': 'Included with your bundle' } });
        atc.style.opacity = '0.6';
        /* This store's cart is the UpCart app, not Dawn's native <cart-drawer>. If UpCart is
           present, let it own the drawer — opening Dawn's drawer on top of it locks body scroll
           and never releases (the freeze). Only fall back to Dawn's drawer when UpCart is absent. */
        var hasUpCart = !!(window.UpCart || window.upcart || document.querySelector('script[src*="upcart"],[id*="upcart"],[id*="UpCart"],[class*="upcart"]'));
        var cartDrawer = hasUpCart ? null : document.querySelector('cart-drawer');
        var body = { items: items };
        if (cartDrawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }, body: JSON.stringify(body) })
          .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, d: d }; }); })
          .then(function(res){
            atc.style.opacity = '';
            if (!res.ok) { alert((res.d && res.d.description) || 'Could not add to cart.'); return; }
            if (hasUpCart) {
              /* UpCart intercepts /cart/add and opens itself; nudge it in case auto-open is off. */
              try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
              try { if (window.UpCart && typeof window.UpCart.openCart === 'function') window.UpCart.openCart(); } catch (e) {}
              return;
            }
            if (cartDrawer && res.d.sections && typeof cartDrawer.renderContents === 'function') {
              try { cartDrawer.renderContents(res.d); }
              catch (err) { if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } else { window.location = '/cart'; } }
            } else if (cartDrawer && typeof cartDrawer.open === 'function') { cartDrawer.open(); }
            else { window.location = '/cart'; }
          })
          .catch(function(){ atc.style.opacity = ''; window.location = '/cart'; });
      });
      render();
    });

    /* ---------- GALLERY: thumb click + mobile swipe ---------- */
    document.querySelectorAll('[data-section="gallery"]').forEach(function(g){
      var label = g.querySelector('[data-gallery-label]');
      var mainWrap = g.querySelector('[data-gallery-main]');
      var mainImg = g.querySelector('[data-gallery-img]');
      var thumbs = [].slice.call(g.querySelectorAll('[data-gallery]'));
      function show(btn){
        thumbs.forEach(function(b){ b.setAttribute('aria-current','false'); });
        btn.setAttribute('aria-current','true');
        var src = btn.getAttribute('data-gallery-src');
        if (src && mainImg) { mainImg.src = src; mainImg.alt = btn.getAttribute('data-gallery') || ''; }
        else if (src && mainWrap) { mainWrap.innerHTML = '<img data-gallery-img src="'+src+'" alt="" style="width:100%;height:100%;object-fit:cover">'; mainImg = mainWrap.querySelector('[data-gallery-img]'); }
        if (label) label.textContent = 'Product image · ' + (btn.getAttribute('data-gallery') || '');
        /* keep the active thumb in view when overlapped/scrolled */
        if (btn.scrollIntoView) btn.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }
      thumbs.forEach(function(btn){ btn.addEventListener('click', function(){ show(btn); }); });
      function curIndex(){ for (var i=0;i<thumbs.length;i++){ if (thumbs[i].getAttribute('aria-current')==='true') return i; } return 0; }
      function go(delta){ if (!thumbs.length) return; var i=(curIndex()+delta+thumbs.length)%thumbs.length; show(thumbs[i]); }
      if (mainWrap){
        var sx = null;
        mainWrap.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
        mainWrap.addEventListener('touchend', function(e){ if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); sx = null; }, {passive:true});
      }
    });

    /* ---------- horizontal rail arrows ---------- */
    document.querySelectorAll('[data-section]').forEach(function(sec){
      var rail = sec.querySelector('[data-rail]');
      if (!rail) return;
      var prev = sec.querySelector('[data-rail-prev]'), next = sec.querySelector('[data-rail-next]');
      var step = function(){ return (rail.firstElementChild ? rail.firstElementChild.offsetWidth + 14 : 280); };
      if (prev) prev.addEventListener('click', function(){ rail.scrollBy({left: -step(), behavior:'smooth'}); });
      if (next) next.addEventListener('click', function(){ rail.scrollBy({left: step(), behavior:'smooth'}); });
    });

    /* ---------- timeline scroll progress ---------- */
    var tl = document.querySelector('[data-timeline]');
    if (tl) {
      var rows = [].slice.call(tl.querySelectorAll('[data-tl-row]'));
      var fill = tl.querySelector('[data-tl-fill]');
      function tick(){
        var threshold = window.innerHeight * 0.62;
        var contTop = tl.getBoundingClientRect().top; var f = 0;
        rows.forEach(function(r){
          var nodeEl = r.querySelector('.tl__node'); if (!nodeEl) return;
          var node = nodeEl.getBoundingClientRect();
          var cy = node.top + node.height/2; var on = cy <= threshold;
          r.setAttribute('data-active', on ? 'true':'false');
          if (on) f = cy - contTop;
        });
        if (fill) fill.style.height = Math.max(0, f - 14) + 'px';
      }
      window.addEventListener('scroll', tick, {passive:true}); window.addEventListener('resize', tick); tick();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
